/**
 * How long the splash stays up even when login settles sooner — long enough for
 * the intro animation (see `splash-screen.component.scss`) to play out.
 */
export const MINIMUM_DISPLAY_MS = 4000;

/**
 * The commodity-icon texture behind the splash, exported from Figma at 2× (served from
 * `public/`). Drawn as a CSS background tiled at the phone frame's size, not stretched to
 * the viewport, so its icons stay phone-sized on a desktop screen too.
 */
export const SPLASH_TEXTURE_URL = 'url(splash-texture.png)';

export const SPLASH_SUBTITLE = 'سامانه معاملات بورس‌کالا';

/** The subtitle fades in one word at a time, in reading order. */
export const SPLASH_SUBTITLE_WORDS = ['سامانه', 'معاملات', 'بورس‌کالا'] as const;
